import { I18nUtils } from '../../../../i18n/I18nUtils';

export class Email {
    _email;

    constructor(email) {
        if ( !email ) {
            throw new Error(I18nUtils.tr('TR_CAMPO_OBLIGATORIO'));
        } else if (this.validateEmail(email)) {
            this._email = email;
        } else {
            throw new Error(I18nUtils.tr('TR_INTRODUCE_UN_EMAIL_VALIDO'));
        }
    }

    get email() {
        return this._email;
    }

    validateEmail(email) {
        const reg = /^[a-zA-Z0-9.+_-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
        return reg.test(email);
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/model/objectvalue/Email.js